// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".departments-area[data-v-1b7b9a1a] {\n  display: flex;\n  flex-direction: column;\n}\n.departments-area .search-box[data-v-1b7b9a1a] {\n    padding-left: 5%;\n    padding-right: 5%;\n}\n.departments-area > .departments-tree[data-v-1b7b9a1a] {\n    position: relative;\n    overflow-y: auto;\n    flex-grow: 1;\n    flex-shrink: 1;\n}\n.departments-area > .departments-tree.small-margin[data-v-1b7b9a1a] {\n      margin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
